import { Setting } from '@/types/settings.types';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useSTKContext } from '@/context/context';

export const useSettings = (enabled: boolean) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<Setting[]>>({
    queryKey: ['settings'],
    queryFn: () => apiClient.get<Setting[]>('/settings'),
    enabled,
  });
};
